import React, { useEffect, useState } from 'react';
import { initializeStatsig } from './statsig';
import AISlopDetector from './AISlopDetector';

function App() {
  const [statsigReady, setStatsigReady] = useState(false);

  useEffect(() => {
    const setupStatsig = async () => {
      try {
        await initializeStatsig();
        setStatsigReady(true);
      } catch (error) {
        console.error('Statsig initialization failed:', error);
        setStatsigReady(true); // Continue without Statsig
      }
    };

    setupStatsig();
  }, []);

  // Show loading while Statsig initializes (optional)
  if (!statsigReady) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontFamily: 'system-ui'
      }}>
        <div>Loading AI Slop Detector...</div>
      </div>
    );
  }

  return <AISlopDetector />;
}

export default App;